/** App semver from root package.json, injected at build time via vite.config.mts */
export const APP_VERSION = __MALU_APP_VERSION__
